/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit DataVaxiomSysOrganizationsLocationSelect/view.blocks to change it.
import Locations from './Locations/index'
import React from 'react'



/** @type {import('Simple/types.js').View} */
export default function DataVaxiomSysOrganizationsLocationSelect({
  children,
  viewPath = "/DesignSystem/DataVaxiomSysOrganizationsLocationSelect",
  allowEmptyChoice,
  marginLeft,
  marginRight,
  marginTop,
  marginBottom
  
}) {
  return (<React.Fragment
>
<Locations
  viewPath={`${viewPath}/Locations`}
 allowEmptyChoice={allowEmptyChoice}
 marginLeft={marginLeft}
 marginRight={marginRight}
 marginTop={marginTop}
 marginBottom={marginBottom}
/>
{children}
</React.Fragment>)
}